import { Box } from '@mui/material'
import React from 'react'

const Contact = () => {
  return (
    <Box minHeight={"79vh"}>
      
    </Box>
  )
}

export default Contact
